import styled from 'styled-components';

import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';
import closeSidebar from '../../assets/imgs/close-sidebar.svg';
import { Divider, Text } from '../common';

export const CustomizeDriver = styled(Divider)`
  border-top: 2px solid ${getThemeColor(['grayBlue'])};
  margin-bottom: 20px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
  }
`;

export const CompaniesWrapS = styled.div`
  margin: 15px auto;
  display: block;
  width: ${getScreenSize(['tabletPC'])};

  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    padding: 0 20px;
    width: 100%;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: none;
  }
`;

export const CompaniesFilterWrapS = styled.div`
  width: 25%;
  min-width: 250px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: none;
  }
`;

export const TextDeleteFilter = styled(Text)`
  font-size: ${getThemeSize(['bigText'])};
  margin-right: 23px;

  &:hover {
    cursor: pointer;
  }
`;

export const CloseIconWrapper = styled(Text)`
  color: ${getThemeColor(['red'])};
  margin: 5px;
`;

export const CompanyItemsWrap = styled.div`
  padding-left: 38px;
  flex-basis: 100%;

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: none;
  }
`;

export const CompanyItemsWrapMobile = styled.div`
  display: none;
  @media (max-width: ${getScreenSize(['medium'])}) {
    display: block;
    padding: 0;
    width: 100%;

    & > a {
      width: 100%;
      margin-bottom: 20px;
      display: flex;

      & > div {
        width: 100%;
      }
    }

    & > a:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const LoaderWrap = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  background-color: rgba(255, 255, 255, 0.6);
  width: ${({ size }) => (size ? size.width : '0px')};
  height: ${({ size }) => (size ? size.height : '0px')};
`;

export const CompanySearchText = styled('h1')`
  font-size: 18px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-size: 13px;
    font-weight: 700;
    line-height: 15.6px;
  }
`;

export const CompaniesFilterBlockS = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: none;
  }
`;

export const CompaniesFilterMobileS = styled.div`
  display: none;
  justify-content: space-between;
  padding: 23px 24px;
  white-space: nowrap;

  & button:nth-child(1) {
    margin-right: 16px;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: flex;
  }
`;

export const CompaniesListButtonS = styled.button`
  width: 50%;
  padding: 10px;
  border-radius: 3px;
  background: ${getThemeColor(['white'])};
  box-shadow: 1px 0px 4px 0px ${getThemeColor(['grayBlue'])};
  font-family: ${getThemeFont(['regular'])};
  font-size: ${getThemeSize(['mediumText'])};
  font-weight: 700;
  line-height: 15.6px;
  color: ${getThemeColor(['violet'])};
  border: none;
  text-align: left;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CompaniesListButtonIconS = styled.img``;

export const CompaniesListButtonFilterS = styled(CompaniesListButtonS)`
  & img {
    margin-left: 8px;
    width: 14px;
    height: 14px;
  }
`;

export const CompaniesListButtonSortS = styled.div`
  min-width: 155px;
  width: 50%;
  box-shadow: 1px 0px 4px 0px ${getThemeColor(['grayBlue'])};

  & div {
    box-shadow: none;
  }

  & div.select-items {
    margin: 0;
  }

  & > div {
    padding: 0;
    width: 100%;
    border-radius: 3px;
    background: ${getThemeColor(['white'])};
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    color: ${getThemeColor(['violet'])};
    display: flex;
    align-items: center;
    cursor: pointer;

    & svg {
      margin-left: 4px;
      margin-top: 2px;
    }
  }
`;

export const DrawerContentS = styled.div`
  height: 100%;
`;

export const DrawerContentHeaderS = styled.div`
  padding: 27px 24px 46px;
  display: flex;
  justify-content: space-between;

  & > h3 {
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: left;
    color: ${getThemeColor(['violet'])};
    position: relative;
    left: -10%;
  }

  & > span {
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['smallText'])};
    font-weight: 400;
    line-height: 13.2px;
    color: ${getThemeColor(['greyViolet'])};
    cursor: pointer;
  }
`;

export const CloseButtonS = styled.button`
  width: 13px;
  height: 13px;
  cursor: pointer;
  outline: none;
  background: transparent;
  border: none;
  background: url(${closeSidebar}) no-repeat center;
  padding: 4px;
`;

export const DrawerFiltersWraperS = styled.div`
  padding-bottom: 85px;
  height: 100%;

  & > div {
    height: 100%;
  }
`;

export const MobileInfiniteLoad = styled.div`
  display: none;

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 22px auto 0;

    & span {
      margin-bottom: 15px;
      font-family: ${getThemeFont(['regular'])};
      font-size: 11px;
      font-weight: 400;
      line-height: 13.2px;
      text-align: left;
      color: #4d4d4d;
    }
  }
`;

export const MobileInfiniteLoadAction = styled.div`
  border: none;
  outline: none;
  color: ${getThemeColor(['lighterViolet'])};
  font-family: ${getThemeFont(['regular'])};
  font-size: ${getThemeSize(['mediumText'])};
  font-weight: 700;
  line-height: 15.6px;
  text-align: left;
  padding: 0;
  display: flex;
  align-items: center;
  cursor: pointer;

  & span {
    margin: 0;
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: left;
    color: ${getThemeColor(['lighterViolet'])};
  }

  & img {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
`;

export const MobileCompaniesWrapS = styled.div`
  width: 100%;
  padding: 0 24px;
  margin: 10px auto;
  display: none;

  @media (max-width: ${getScreenSize(['medium'])}) {
    padding: 0;
    margin: 10px auto;
    display: block;
    & .filters-drawer {
      height: 85% !important;
    }

    & .filter-Item {
      margin: 15px 0 0;

      & > div.filter-Item-label {
        padding: 0 24px;
        font-family: ${getThemeFont(['regular'])};
        font-size: ${getThemeSize(['normalText'])};
        font-weight: 700;
        line-height: 16.8px;
        color: ${getThemeColor(['violet'])};
      }

      & > div.filter-Item-options {
        padding: 0 24px 0 38px;
        margin-top: 16px;

        & > div {
          margin-bottom: 10px;

          &:last-of-type {
            margin-bottom: 3px;
          }
        }
      }

      & > div.filter-Item-input {
        margin: 0 24px;

        & input {
          height: 30px;
          background: ${getThemeColor(['greyLight'])};
          padding: 8px 13px 9px;

          &::placeholder {
            font-family: ${getThemeFont(['regular'])};
            font-size: ${getThemeSize(['smallText'])};
            font-weight: 400;
            line-height: 13.2px;
            text-align: left;
          }
        }
      }

      &:first-of-type {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid ${getThemeColor(['grayBlue'])};
      }
    }

    & .filters-wrapper {
      padding: 0;
    }
    & .heading-text {
      margin-bottom: 7px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;

      & span,
      & h1 {
        font-family: ${getThemeFont(['regular'])};
        font-size: ${getThemeSize(['mediumText'])};
        font-weight: 700;
        line-height: 15.6px;
        text-align: left;
        color: ${getThemeColor(['darkerViolet'])};
      }
    }
  }
`;

export const CompaniesItemsWrapS = styled.div`
  width: 100%;
  margin: 0px 0px 20px;
  border-left: 2px solid ${getThemeColor(['grayBlue'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    border-left: none;
    padding: 0 24px;
  }
`;

export const NoCompaniesFoundS = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & span:first-of-type {
    margin-bottom: 30px;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
    display: flex;
    flex-direction: column;
    padding: 10px 24px;
    font-size: ${getThemeSize(['smallText'])};

    & span {
      font-size: ${getThemeSize(['smallText'])};
    }
    & span:first-of-type {
      margin-bottom: 10px;
    }
  }
`;
